export const DEFAULT_COLUMNS = [
  { label: "Id", id: "id", show: true },
  { label: "Name", id: "name", show: true },
  { label: "Description", id: "description", show: true },
];
